/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
// import { useLocation, Navigate } from "react-router-dom";
import { USER_ROLE, ROUTE_ENUM } from "enums";
import { useGetMe } from "hooks/auth";
import { useOfflineAuth } from "hooks/useOfflineAuth";
import { ProtectedRouteProps } from "types/routeTypes";
import { DashboardRouter } from "pages";

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  isAdminOnly = false,
}) => {
  // const location = useLocation();
  const { data: authorizedUser, isLoading, refetch } = useGetMe();
  const {
    isAuthenticated: isOfflineAuthenticated,
    user: offlineUser,
    isLoading: isOfflineLoading,
  } = useOfflineAuth();

  // const [shouldRedirect, setShouldRedirect] = useState<string | null>(null);

  // useEffect(() => {
  //   if (navigator.onLine) {
  //     refetch();
  //   }
  // }, [location]);

  // useEffect(() => {
  //   if (shouldRedirect && navigator.onLine) {
  //     window.location.href = shouldRedirect;
  //   }
  // }, [shouldRedirect]);

  useEffect(() => {
    const handleOnline = () => {
      if (navigator.onLine) {
        refetch();
      }
    };

    window.addEventListener("online", handleOnline);
    return () => window.removeEventListener("online", handleOnline);
  }, [refetch]);

  if (isLoading || isOfflineLoading) {
    return <div>Loading...</div>;
  }

  if (!navigator.onLine) {
    if (isOfflineAuthenticated && offlineUser) {
      const role = offlineUser?.role;
      const isCorrect = isAdminOnly ? role === USER_ROLE.admin : true;
      if (isCorrect) {
        return <DashboardRouter />;
      }
    }
  }

  let userData = authorizedUser;
  if (userData && navigator.onLine) {
    try {
      localStorage.setItem("userData", JSON.stringify(userData));
    } catch (error) {
      console.error("Error saving user data to localStorage:", error);
    }
  }

  const isAuthenticated = !!userData?.role;
  const role = userData?.role;
  const isCorrect = isAdminOnly
    ? isAuthenticated && role === USER_ROLE.admin
    : isAuthenticated;

  if (!isCorrect) {
    const user = sessionStorage.getItem("loginAdmin");
    const route = user ? ROUTE_ENUM.LOGIN : ROUTE_ENUM.HOME;

    try {
      return <Navigate to={route} replace />;
    } catch (navError) {
      console.error("Navigate error:", navError);
      window.location.href = route;
      return <div>Redirecting...</div>;
    }
  }
  return <DashboardRouter />;
};

export default ProtectedRoute;
